"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UserProfile_styles_1 = require("./UserProfile.styles");
var UserProfile_classNames_1 = require("./UserProfile.classNames");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var UserGroup = /** @class */ (function (_super) {
    __extends(UserGroup, _super);
    function UserGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserGroup.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className, role: "listitem" }, this.props.group.name));
    };
    return UserGroup;
}(React.Component));
var UserProfile = /** @class */ (function (_super) {
    __extends(UserProfile, _super);
    function UserProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfile.prototype._renderName = function () {
        return (React.createElement("div", { className: this._classNames.name }, this.props.userProfile.display_name));
    };
    UserProfile.prototype._renderEmail = function () {
        return (React.createElement("div", { className: this._classNames.email }, this.props.userProfile.user.email));
    };
    UserProfile.prototype._renderDetails = function () {
        return (React.createElement("div", { className: this._classNames.details },
            this._renderName(),
            this._renderEmail()));
    };
    UserProfile.prototype._renderPhoto = function () {
        return (React.createElement("div", { className: this._classNames.photo },
            React.createElement("div", { className: this._classNames.photoIconContainer },
                React.createElement(Icon_1.Icon, { iconName: "Contact", className: "photo-icon" }))));
    };
    UserProfile.prototype._renderHeader = function () {
        return (React.createElement("div", { className: this._classNames.header },
            this._renderPhoto(),
            this._renderDetails()));
    };
    UserProfile.prototype._renderGroups = function () {
        var _this = this;
        var groups = this.props.userProfile.user.groups;
        if (groups && groups.length > 0) {
            return (React.createElement("div", { className: this._classNames.groups, role: "list" }, groups.map(function (g) { return React.createElement(UserGroup, { key: g.name, group: g, className: _this._classNames.group }); })));
        }
        return null;
    };
    UserProfile.prototype._renderBody = function () {
        return (React.createElement("div", { className: this._classNames.body }, this._renderGroups()));
    };
    UserProfile.prototype.render = function () {
        this._classNames = UserProfile_classNames_1.getClassNames(UserProfile_styles_1.getStyles(null, this.props.styles), this.props.className);
        return (React.createElement("div", { className: this._classNames.root },
            this._renderHeader(),
            this._renderBody()));
    };
    return UserProfile;
}(React.Component));
exports.UserProfile = UserProfile;
